import { createSlice } from '@reduxjs/toolkit';
import getAdapter from '../getAdapter';

const insuranceSizeCategoriesAdapter = getAdapter({ idFieldName: 'value' });

const insuranceSizeCategoriesSlice = createSlice({
  name: 'insuranceSizeCategories',
  initialState: insuranceSizeCategoriesAdapter.getInitialState(),
  reducers: {
    setInsuranceSizeCategories: (state, { payload: { insuranceSizeCategories } }) => {
      insuranceSizeCategoriesAdapter.setAll(state, insuranceSizeCategories);
    },
  },
});

const selectors = insuranceSizeCategoriesAdapter.getSelectors(({ insuranceSizeCategories }) => insuranceSizeCategories);

export const getInsuranceSizeCategories = (state) => selectors.selectAll(state);

export const {
  setInsuranceSizeCategories,
} = insuranceSizeCategoriesSlice.actions;

export default insuranceSizeCategoriesSlice.reducer;
